type RequestIdleCallback = (
  callback: () => void,
  options?: { timeout: number }
) => number;

const appendHeadLink = (rel: 'dns-prefetch' | 'preconnect', href: string) => {
  if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) {
    return;
  }

  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;

  document.head.appendChild(link);
};

export const warmupHomepageConnection = () => {
  const href = window.location.protocol + '//' + window.location.host;

  appendHeadLink('dns-prefetch', href);

  const startPreconnect = () => {
    appendHeadLink('preconnect', href);
    removeListeners();
  };

  const onWindowLoad = () => {
    const requestIdleCallback = (window as Window & {
      requestIdleCallback?: RequestIdleCallback;
    }).requestIdleCallback;

    if (requestIdleCallback) {
      requestIdleCallback(startPreconnect, { timeout: 1500 });
      return;
    }

    window.setTimeout(startPreconnect, 0);
  };

  const interactionEvents: Array<keyof WindowEventMap> = [
    'pointerdown',
    'touchstart',
    'keydown',
  ];

  const removeListeners = () => {
    window.removeEventListener('load', onWindowLoad);

    interactionEvents.forEach((eventName) => {
      window.removeEventListener(eventName, startPreconnect, true);
    });
  };

  if (document.readyState === 'complete') {
    onWindowLoad();
  } else {
    window.addEventListener('load', onWindowLoad, { once: true });
  }

  interactionEvents.forEach((eventName) => {
    window.addEventListener(eventName, startPreconnect, {
      once: true,
      capture: true,
    });
  });

  return removeListeners;
};
